import React from 'react';
import BaseIcon from './BaseIcon';

class CloseSVG extends BaseIcon {
  render() {
    const { className, fillColor, height, width, strokeWidth = '2px', onClick = null } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
        className={className}
        onClick={onClick}
      >
        <path
          d="M1 1l20 20M21 1L1 21"
          fill="none"
          stroke={fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default CloseSVG;
